import skuConversionUtils from './skuconversion';
import {get, listAll, post} from './utils';

const dao = {
  initSku: (skuType = 'EYESHADOW', platformData) =>
    skuConversionUtils.initSku(skuType, platformData),
  querySku: async skuId =>
    skuConversionUtils.fromDb(
      await get('/smb-backend/sku/query-sku.action', {skuId})
    ),
  listAllSkus: params => listAll(dao.listSkus, params),
  listSkus: async params =>
    skuConversionUtils.fromDb(
      await get('/smb-backend/sku/list-skus.action', params)
    ),
  listAllSkusBySkuType: params => listAll(dao.listSkusBySkuType, params),
  listSkusBySkuType: async params =>
    skuConversionUtils.fromDb(
      await get('/smb-backend/sku/list-skus-by-sku-type.action', params)
    ),
  createSku: async sku =>
    skuConversionUtils.fromDb(
      await post(
        '/smb-backend/sku/create-sku.action',
        skuConversionUtils.toDb(sku)
      )
    ),
  updateSku: async sku =>
    skuConversionUtils.fromDb(
      await post(
        '/smb-backend/sku/update-sku.action',
        skuConversionUtils.toDb(sku)
      )
    ),
  deleteSku: skuId => get('/smb-backend/sku/delete-sku.action', {skuId}),
  existSkuId: (skuId, skuNo) =>
    get('/smb-backend/sku/exist-sku-no.action', {
      skuId,
      skuNo,
    }),
  querySkus: async params => {
    const results = await get('/smb-backend/sku/query-skus.action', params);
    return results.map(r => skuConversionUtils.fromDb(r));
  },
  countEnabled: () => get('/smb-backend/sku/count-enabled.action'),
  queryDataUrl: url =>
    get('/smb-backend/woocommerce/query-data-url.action', {url}),
  enableSku: async skuId =>
    skuConversionUtils.fromDb(
      await get('/smb-backend/sku/enable-sku.action', {skuId})
    ),
  disableSku: async skuId =>
    skuConversionUtils.fromDb(
      await get('/smb-backend/sku/disable-sku.action', {skuId})
    ),
  copySku: async skuId => 
      skuConversionUtils.fromDb(
        await get('/smb-backend/sku/copy-sku.action', {skuId})
      ),
};

export default dao;
